"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var login_service_1 = require("app/main/content/_service/login.service");
var class_instance_service_1 = require("app/main/content/_service/meta/core/class/class-instance.service");
var stored_chart_service_1 = require("app/main/content/_service/stored-chart.service");
var core_tenant_service_1 = require("app/main/content/_service/core-tenant.service");
var stored_chart_1 = require("app/main/content/_model/stored-chart");
var util_1 = require("util");
var local_repository_jsonServer_service_1 = require("app/main/content/_service/local-repository-jsonServer.service");
var user_1 = require("app/main/content/_model/user");
var local_repository_dropbox_service_1 = require("app/main/content/_service/local-repository-dropbox.service");
var ManagementSummaryComponent = /** @class */ (function () {
    function ManagementSummaryComponent(loginService, classInstanceService, storedChartService, tenantService, lrDropboxService, lrJsonServerService) {
        this.loginService = loginService;
        this.classInstanceService = classInstanceService;
        this.storedChartService = storedChartService;
        this.tenantService = tenantService;
        this.lrDropboxService = lrDropboxService;
        this.lrJsonServerService = lrJsonServerService;
        // comparison chart
        this.comparisonXlabel = "Jahr";
        this.comparisonYlabel = "Anzahl Tätigkeiten";
        this.colorScheme = "cool";
        this.schemeType = "ordinal";
        this.showGridLines = true;
        this.animations = true;
        this.gradient = false;
        this.showXAxis = true;
        this.showYAxis = true;
        this.showXAxisLabel = true;
        this.showYAxisLabel = true;
        this.xAxisLabel = "Datum";
        this.yAxisLabel = "Dauer [Stunden]";
        this.noBarWhenZero = true;
        this.showLabels = true;
        this.autoScale = true;
        this.legend = false;
        this.legendPosition = "below";
        this.tooltipDisabled = false;
        this.marketplace = [];
        this.classInstanceDTOs = [];
        this.uniqueYears = [];
        this.uniqueTenants = [];
        this.subscribedTenants = [];
        this.durationTotal = [];
        this.numberTotal = [];
        this.durationYear = [];
        this.numberYear = [];
        this.comparisonData = [];
        this.isLoaded = false;
        this.percentageFilteredOut = 0;
    }
    ManagementSummaryComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var globalInfo, localClassInstances, _a, e_1, _b, before, after, uniqueTenantIds, allTenants;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.loginService.getGlobalInfo().toPromise()];
                    case 1:
                        globalInfo = (_c.sent());
                        this.volunteer = globalInfo.user;
                        this.marketplace = globalInfo.marketplace;
                        this.subscribedTenants = globalInfo.tenants;
                        this.comparisonYear = 2019;
                        this.engagementYear = 2019;
                        this.localRepositoryService = this.loginService.getLocalRepositoryService(this.volunteer);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 5, , 8]);
                        return [4 /*yield*/, this.localRepositoryService
                                .findClassInstancesByVolunteer(this.volunteer)
                                .toPromise()];
                    case 3:
                        localClassInstances = (_c.sent());
                        // TODO
                        // get unique marketplaceIds of CIs
                        // perform once per marketplaceId
                        _a = this;
                        return [4 /*yield*/, this.classInstanceService
                                .mapClassInstancesToDTOs(this.marketplace, localClassInstances)
                                .toPromise()];
                    case 4:
                        // TODO
                        // get unique marketplaceIds of CIs
                        // perform once per marketplaceId
                        _a.classInstanceDTOs = (_c.sent());
                        this.isLocalRepositoryConnected = true;
                        return [3 /*break*/, 8];
                    case 5:
                        e_1 = _c.sent();
                        this.isLocalRepositoryConnected = false;
                        if (!!util_1.isNullOrUndefined(this.marketplace)) return [3 /*break*/, 7];
                        _b = this;
                        return [4 /*yield*/, this.classInstanceService
                                .getUserClassInstancesByArcheType(this.marketplace, "TASK", this.volunteer.id, this.volunteer.subscribedTenants.map(function (s) { return s.tenantId; }))
                                .toPromise()];
                    case 6:
                        _b.classInstanceDTOs = (_c.sent());
                        _c.label = 7;
                    case 7: return [3 /*break*/, 8];
                    case 8:
                        before = this.classInstanceDTOs.length;
                        this.classInstanceDTOs = this.classInstanceDTOs.filter(function (ci) {
                            return (ci.name != null &&
                                ci.tenantId != null &&
                                ci.dateFrom &&
                                ci.taskType1 &&
                                ci.duration &&
                                !isNaN(Number(ci.duration)));
                        });
                        after = this.classInstanceDTOs.length;
                        this.percentageFilteredOut = (1 - after / before) * 100;
                        this.uniqueYears = __spread(new Set(this.classInstanceDTOs.map(function (item) {
                            return new Date(item.dateFrom).getFullYear();
                        })));
                        this.uniqueYears.sort();
                        uniqueTenantIds = __spread(new Set(this.classInstanceDTOs.map(function (item) { return item.tenantId; })));
                        return [4 /*yield*/, this.tenantService.findAll().toPromise()];
                    case 9:
                        allTenants = _c.sent();
                        this.uniqueTenants = allTenants.filter(function (t) {
                            return uniqueTenantIds.indexOf(t.id) !== -1;
                        });
                        this.generateComparisonChartData(this.comparisonYear);
                        this.generateEngagementYearData(this.engagementYear);
                        this.generateEngagementTotalData();
                        this.isLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    ManagementSummaryComponent.prototype.generateComparisonChartData = function (comparisonYear) {
        var _this = this;
        this.uniqueTenants.forEach(function (tenant) {
            var yearData = _this.classInstanceDTOs
                .filter(function (ci) {
                return new Date(ci.dateFrom).getFullYear() === comparisonYear;
            })
                .filter(function (ci) {
                return ci.tenantId === tenant.id;
            });
            _this.comparisonData.push({ name: tenant.name, value: yearData.length });
        });
        var finalData = [];
        this.uniqueYears.sort();
        this.uniqueYears.forEach(function (curYear) {
            var data = [];
            _this.uniqueTenants.forEach(function (tenant) {
                var currentData = _this.classInstanceDTOs
                    .filter(function (ci) {
                    return new Date(ci.dateFrom).getFullYear() === curYear;
                })
                    .filter(function (ci) {
                    return ci.tenantId === tenant.id;
                });
                data.push({
                    name: tenant.name,
                    value: currentData.length -
                        _this.comparisonData.find(function (d) { return d.name === tenant.name; }).value,
                });
            });
            finalData.push({ name: curYear.toString(), series: data });
        });
        this.comparisonData = __spread(finalData);
    };
    ManagementSummaryComponent.prototype.generateEngagementYearData = function (engagementYear) {
        var _this = this;
        this.engagementYear = engagementYear;
        var classInstancesYear = this.classInstanceDTOs.filter(function (ci) {
            return new Date(ci.dateFrom).getFullYear() === _this.engagementYear;
        });
        this.durationYear = [];
        this.numberYear = [];
        this.uniqueTenants.forEach(function (tenant) {
            var classInstancesTenant = classInstancesYear.filter(function (ci) {
                return ci.tenantId === tenant.id;
            });
            var duration = classInstancesTenant.reduce(function (acc, curr) { return acc + Number(curr.duration); }, 0);
            _this.durationYear.push({ name: tenant.name, value: duration });
            _this.numberYear.push({
                name: tenant.name,
                value: classInstancesTenant.length,
            });
        });
        this.durationYear = __spread(this.durationYear);
        this.numberYear = __spread(this.numberYear);
    };
    ManagementSummaryComponent.prototype.generateEngagementTotalData = function () {
        var _this = this;
        this.uniqueTenants.forEach(function (tenant) {
            var classInstancesTenant = _this.classInstanceDTOs.filter(function (ci) {
                return ci.tenantId === tenant.id;
            });
            var duration = classInstancesTenant.reduce(function (acc, curr) { return acc + Number(curr.duration); }, 0);
            _this.durationTotal.push({ name: tenant.name, value: duration });
            _this.numberTotal.push({
                name: tenant.name,
                value: classInstancesTenant.length,
            });
        });
    };
    ManagementSummaryComponent.prototype.exportChart = function (source) {
        var storedChart;
        switch (source) {
            case "Vergleich":
                storedChart = new stored_chart_1.StoredChart("Vergleich der Anzahl an Tätigkeiten", "ngx-charts-bar-vertical-2d", JSON.stringify(this.comparisonData), this.volunteer.id);
                this.storedChartService.save(this.marketplace, storedChart).toPromise();
                break;
        }
    };
    ManagementSummaryComponent.prototype.valueFormattingDuration = function (c) {
        return c + " Stunden";
    };
    ManagementSummaryComponent.prototype.valueFormattingNumber = function (c) {
        return c + " T\u00E4tigkeiten";
    };
    ManagementSummaryComponent.prototype.getMemberSince = function (tenantId) {
        var t = this.classInstanceDTOs.filter(function (ci) {
            return ci.tenantId === tenantId;
        });
        var uniqueYears = __spread(new Set(t.map(function (item) { return new Date(item.dateFrom).getFullYear(); })));
        return Math.min.apply(Math, uniqueYears);
    };
    ManagementSummaryComponent.prototype.getEngagementSince = function () {
        var uniqueYears = __spread(new Set(this.classInstanceDTOs.map(function (item) {
            return new Date(item.dateFrom).getFullYear();
        })));
        return (Math.min.apply(Math, uniqueYears) +
            " - " +
            Math.max.apply(Math, uniqueYears));
    };
    return ManagementSummaryComponent;
}());
exports.ManagementSummaryComponent = ManagementSummaryComponent;
